<template>
  <router-view />
  <notifications position="top right" :max="4" :ignoreDuplicates="true" />
</template>

<style lang="scss">
@use '@/assets/const.scss' as *;
@import url('https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+Antique:wght@400;700&display=swap');

:root body {
  --bs-body-font-family: 'Zen Kaku Gothic Antique', sans-serif;
  --bs-body-color: #404040;
}

body {
  min-width: 320px;
  min-height: 100vh;

  &.loading {
    overflow: hidden;
  }
}

nav ~ main {
  position: relative;
  margin-top: $headerHeight;
  padding-bottom: 180px;

  h1,
  h2 {
    margin: 0;
    padding: 35px 10px 25px;
    text-align: center;
    @media (min-width: $tablet) {
      padding: 35px 20px 25px;
      text-align: left;
    }
    @media (min-width: $desktop) {
      padding: 35px 40px 25px;
    }

    span {
      display: inline-block;
      word-break: break-all;
    }
  }
}

input[type='text'],
input[type='password'],
button,
select {
  outline: none;
  border: none;
  border-radius: 0;
  background-color: transparent;
}

input.field,
select {
  padding: 5px;
  border: 1px solid var(--bs-gray-400);
  border-radius: 5px;
}

.vue-notification-group {
  top: 0 !important;
  right: 0 !important;
  width: 300px !important;
  padding-top: 70px;
  z-index: 0 !important;
}

.vue-notification-wrapper {
  margin-bottom: 12px;
  transition: all 0.3s ease;
}

.vue-notification-template {
  min-height: 55px !important;
  line-height: 1.5;
  background-color: #fefefe;
  border-radius: 2px;

  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-break: break-word !important;

  display: flex;
  align-items: center;
}

.notification-content {
  font-size: 16px !important;
  color: #333;
  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-break: break-word !important;
}
</style>
